import type { NodoDoc } from "./Documento"

/** Lo que devuelve la API de la biblioteca y del manual. */

export const TIPOS_DOC = ["COD", "MAN", "PLA", "POL", "PRO"] as const
export type TipoDoc = (typeof TIPOS_DOC)[number]

/** Cómo se llama cada sigla en pantalla. La sigla va en el código, no en la vista. */
export const NOMBRE_TIPO: Record<TipoDoc, string> = {
  COD: "Códigos",
  MAN: "Manuales",
  PLA: "Planes",
  POL: "Políticas",
  PRO: "Procedimientos",
}

export const ESTADOS_DOC = ["BORRADOR", "VIGENTE", "OBSOLETO"] as const
export type EstadoDoc = (typeof ESTADOS_DOC)[number]

/**
 * El tono de cada estado.
 *
 * ⚠ **`OBSOLETO` va en rojo y no en gris.** Gris se lee como «inactivo, da igual»;
 * en un SGI un documento obsoleto es uno que alguien puede estar siguiendo por
 * error, y eso es lo que hay que ver de un vistazo.
 */
export const TONO_ESTADO: Record<EstadoDoc, "neutro" | "exito" | "peligro"> = {
  BORRADOR: "neutro",
  VIGENTE: "exito",
  OBSOLETO: "peligro",
}

export type DocumentoResumen = {
  id: number
  tipo: TipoDoc
  numero: number
  codigo: string
  titulo: string
  subtitulo: string | null
  version: string
  estado: EstadoDoc
  fecha_emision: string | null
  proxima_revision: string | null
  versiones_publicadas: number
}

export type Documento = DocumentoResumen & {
  clasificacion: string | null
  /**
   * Quién elabora, revisa y aprueba. Es TEXTO porque quien firma suele ser un
   * ÓRGANO —«Junta de Socios», «Comité de Ética»—, no una persona del expediente:
   * ver `models/biblioteca.py`.
   */
  elaborado_por: string | null
  revisado_por: string | null
  aprobado_por: string | null
  relacionados: string[]
  cuerpo: NodoDoc | null
}

export type VersionDoc = {
  id: number
  version: string
  notas: string | null
  publicado_por: number | null
  creado_en: string
}

export type VersionDetalle = VersionDoc & {
  snapshot: Record<string, unknown> & { cuerpo?: NodoDoc | null }
}
